import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
import querystring from 'querystring'

const categoryApi = {
  list (params) {
    return axios.get(
      `${ApiSetting.baseUrl}/api/categories/`,
      {params: params})
  },
  detail (categoryId, params) {
    return axios.get(
      `${ApiSetting.baseUrl}/api/categories/${categoryId}/`,
      {params: params})
  },
  create (params) {
    // 创建新栏目
    // return axios.post(
    //   `api/categories/`, querystring.stringify(params))
    return axios.post(
      `${ApiSetting.baseUrl}/api/categories/`, querystring.stringify(params))
  }
}

export default categoryApi
